/*
 * 5-М5 «Перерыв». Экран целиком под одно касание (ТЗ §5.7): кнопки длительностей
 * на всю ширину, 48 px, та же высота, что у подвала карточки записи мастера.
 */

.body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--space-1) var(--space-4) var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.gap {
  margin: var(--space-4);
}

.title {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
}

.sub {
  margin: var(--space-1) 0 0;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  line-height: 1.4;
}

.options {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.option {
  width: 100%;
  font-variant-numeric: tabular-nums;
}

.recovery {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-3);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  background: var(--bg-card);
}

.recoveryText {
  margin: 0;
  line-height: 1.4;
}

.custom {
  margin: 0;
  padding: var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.legend {
  padding: 0 var(--space-1);
  font-weight: var(--font-weight-semibold);
}

.times {
  display: flex;
  gap: var(--space-3);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  flex: 1;
}

.field input {
  min-height: 44px;
  padding: 0 var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-card);
  color: var(--text-primary);
  font: inherit;
  font-size: var(--font-size-md);
}

.section {
  margin: 0 0 var(--space-2);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
}

.list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  font-variant-numeric: tabular-nums;
}

.muted {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
}
